/**
 * @file diagnostics — TEMPORARY logging to make it obvious, in the browser
 * console, exactly which competition is being loaded and played.
 *
 * Remove (or gate behind a debug flag) once archived playback is confirmed
 * working end to end. Every message is prefixed so it is easy to filter/find.
 */

const TAG = '[SCR Weekly]';

/**
 * Logged when the user presses Play, before Unity boots.
 * @param {string} manifestUrl
 * @param {{ archived?: boolean }} [opts]
 */
export function logLaunch(manifestUrl, opts = {}) {
  // eslint-disable-next-line no-console
  console.log(
    `${TAG} Launching challenge:\n` +
      `manifestUrl = ${manifestUrl}\n` +
      `mode = ${opts.archived ? 'archived' : 'current'}`
  );
}

/**
 * Logged when Unity's manifest request is (re)pointed at a manifest — i.e. when
 * the loader is about to download it.
 * @param {string} url
 */
export function logLoadingManifest(url) {
  // eslint-disable-next-line no-console
  console.log(`${TAG} Loading manifest:\n${url}`);
}

/**
 * Logged when a manifest has been fetched + parsed, so it is immediately clear
 * which season/week/title is actually in play.
 * @param {import('../models/manifest').Competition} competition
 */
export function logCompetition(competition) {
  if (!competition) return;
  // eslint-disable-next-line no-console
  console.log(
    `${TAG} Competition:\n` +
      `Season ${competition.season}\n` +
      `Week ${competition.week}\n` +
      `Title ${competition.title}`
  );
}
